/* ODCAF Express — shared order box for print products (signs, banners, magnets, invitations, stickers, mugs…).
   Reads a small JSON config from the product template and builds:
   options (saved on the order), paid add-ons (added as their own cart lines), "design it for me",
   notes, and the artwork upload + preview (handled by odcaf-bc-preview.js, which must load after this file). */
(function () {
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var UP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>';
  function line(color) {
    return '<svg class="odx-bcu__line" aria-hidden="true"><rect x="0" y="0" width="100%" height="100%" fill="none" stroke="#fff" stroke-width="2"/><rect x="0" y="0" width="100%" height="100%" fill="none" stroke="' + color + '" stroke-width="2" stroke-dasharray="6 4"/></svg>';
  }

  function build(host, cfg) {
    var sid = cfg.sid, fid = 'product-form-' + sid;
    var money;
    try { var nf = new Intl.NumberFormat(undefined, { style: 'currency', currency: cfg.currency || 'USD' }); money = function (c) { return nf.format(c / 100).replace(/\.00$/, ''); }; }
    catch (e) { money = function (c) { return '$' + (c / 100).toFixed(2); }; }
    var noun = cfg.noun || 'item';
    cfg.__money = money;
    var h = '';

    /* options + paid add-ons */
    var groups = (cfg.options || []);
    if (groups.length) {
      h += '<div class="odx-pdp odx-po"><p class="odx-pdp-h">' + esc(cfg.optionsHeading || 'Choose your options') + '</p>';
      groups.forEach(function (g, gi) {
        h += '<div class="odx-po__group" data-when="' + esc(g.when || '') + '"><p class="odx-opt-h">' + esc(g.name) + '</p><div class="odx-po__pills" role="radiogroup" aria-label="' + esc(g.name) + '">';
        g.values.forEach(function (v, vi) {
          var attrs = ' name="properties[' + esc(g.name) + ']" value="' + esc(v.label) + '" form="' + fid + '"';
          if (v.id) attrs += ' data-odx-addon data-id="' + v.id + '" data-price="' + (v.price || 0) + '"' + (v.once ? ' data-once' : '');
          if (v.back === true) attrs += ' data-back="1"';
          if (v.back === false) attrs += ' data-back="0"';
          if (v.size) attrs += ' data-size="' + esc(v.size) + '"';
          var note = v.note || (v.id && v.price ? '+' + money(v.price) + (v.once ? '' : ' per ' + noun) : '');
          h += '<label class="odx-bc-pill"><input type="radio"' + attrs + (vi === 0 ? ' checked' : '') + '><span><b>' + esc(v.label) + '</b>' + (note ? '<small>' + esc(note) + '</small>' : '') + '</span></label>';
        });
        h += '</div></div>';
      });
      h += '</div>';
    }

    /* artwork step: design option */
    h += '<div class="odx-pdp odx-bc"><p class="odx-pdp-h">' + esc(cfg.artworkHeading || 'Artwork') + '</p>';
    if (cfg.design && cfg.design.id) {
      h += '<label class="odx-bc-design"><input type="checkbox" data-odx-design data-price="' + cfg.design.price + '"><span class="odx-bc-design__box"><b>' + esc(cfg.design.label || 'Design it for me') + ' <em>+' + money(cfg.design.price) + '</em></b><small>No design yet? Our team will create it for you. We’ll contact you to confirm the details before printing.</small></span></label>' +
        '<div class="odx-bc-design__more" data-odx-design-more hidden><input type="hidden" name="properties[Design service]" value="Yes — design it for me (+' + money(cfg.design.price) + ')" form="' + fid + '" data-odx-design-flag disabled>' +
        '<label class="odx-bc-notes"><span>What should we put on your ' + esc(noun) + '?</span><textarea rows="4" name="properties[Design details]" form="' + fid + '" data-odx-design-notes disabled placeholder="' + esc(cfg.design.placeholder || 'Text, phone, website, colors or style you like… You can also upload your logo or photos below.') + '"></textarea></label></div>';
    }
    h += '</div>';

    /* upload + preview */
    var sides = cfg.sides || [['front', 'Front', '(required)']];
    h += '<div class="odx-bcu" data-odx-bcu data-form="' + fid + '" data-section="' + esc(sid) + '" data-noun="' + esc(noun) + '"' +
      (cfg.bleed ? ' data-bleed="' + cfg.bleed + '"' : '') + (cfg.trim ? ' data-trim="' + cfg.trim + '"' : '') +
      (cfg.safe != null ? ' data-safe="' + cfg.safe + '"' : '') + (cfg.size ? ' data-size="' + esc(cfg.size) + '"' : '') +
      (cfg.round ? ' data-round' : '') + (cfg.plain ? ' data-plain' : '') + (cfg.dpi ? ' data-dpi="' + cfg.dpi + '"' : '') + '>';
    h += '<p class="odx-opt-h">Upload &amp; preview your artwork</p>';
    h += '<p class="odx-bcu__intro" data-intro>' + esc(cfg.intro || 'Upload your design and check it against the cut lines before you order. PNG, JPG or PDF work best.') + '</p>';
    h += '<p class="odx-bcu__size" data-size-label></p><div class="odx-bcu__slots">';
    sides.forEach(function (sd) {
      var key = sd[0], label = sd[1], note = sd[2] || '';
      h += '<div class="odx-bcu__slot" data-slot="' + esc(key) + '"><div class="odx-bcu__top"><b>' + esc(label) + (note ? ' <small' + (/required/.test(note) ? ' class="odx-bcu__req"' : '') + '>' + esc(note) + '</small>' : '') + '</b>' +
        '<span class="odx-bcu__btns"><button type="button" class="odx-bcu__btn odx-bcu__btn--ghost" data-remove>Remove</button><button type="button" class="odx-bcu__btn" data-pick>Upload</button></span></div>' +
        '<input class="odx-bcu__file" type="file" name="properties[' + esc(label) + ' artwork]" form="' + fid + '" accept="image/png,image/jpeg,image/webp,application/pdf,.pdf,.png,.jpg,.jpeg,.ai,.eps,.psd" tabindex="-1" aria-label="' + esc(label) + ' artwork file">' +
        '<div class="odx-bcu__frame"><div class="odx-bcu__card"><img class="odx-bcu__img" alt="' + esc(label) + ' artwork preview"><div class="odx-bcu__empty">' + UP + '<b>' + esc(/^your\s/i.test(label) ? 'Drop ' + label.toLowerCase() + ' here' : 'Drop your ' + label.toLowerCase() + ' here') + '</b><span>or click to choose a file</span></div>' +
        (cfg.wrap ? '<span class="odx-bcu__trim" style="left:0;right:0;top:0;bottom:0" aria-hidden="true">' + line('#e0202f') + '</span>' : '') +
        '<span class="odx-bcu__trim" aria-hidden="true">' + line(cfg.wrap ? '#1d8fe0' : '#e0202f') + '</span><span class="odx-bcu__safe" aria-hidden="true">' + line('#0e9f35') + '</span></div></div>' +
        '<p class="odx-bcu__name" data-name></p><ul class="odx-bcu__msgs" data-msgs aria-live="polite"></ul></div>';
    });
    var legend = cfg.wrap
      ? '<li><i class="l-trim"></i>Red = bleed line (extend your background to here)</li><li><i class="l-trim" style="border-color:#1d8fe0"></i>Blue = outer edge (outside it wraps around the side)</li><li><i class="l-safe"></i>Green = safe area (keep text &amp; faces inside)</li>'
      : '<li><i class="l-trim"></i>Red = cut line (anything outside is trimmed off)</li><li><i class="l-safe"></i>Green = safe area (keep text &amp; logos inside)</li>';
    h += '</div><div class="odx-bcu__bar"><ul class="odx-bcu__legend">' + legend + '</ul>' +
      '<div class="odx-bcu__toggles"><label><input type="checkbox" data-guides checked> Guides</label><label><input type="checkbox" data-cut> ' + (cfg.wrap ? 'Show front view' : 'Show as cut') + '</label></div></div>';
    if (cfg.notes !== false) {
      h += '<label class="odx-bc-notes"><span>Notes for us <small style="font-weight:500;color:#5b5d6b">(optional)</small></span><textarea rows="2" name="properties[Notes]" form="' + fid + '" data-odx-notes placeholder="' + esc(cfg.notesPlaceholder || 'Anything we should know about your order?') + '"></textarea></label>';
    }
    h += '<p class="odx-bcu__error" data-error role="alert" hidden></p></div>';
    host.innerHTML = h;

    /* variant data for the preview script */
    var vs = document.createElement('script');
    vs.type = 'application/json';
    vs.id = 'OdxBCVariants-' + sid;
    vs.textContent = JSON.stringify(cfg.variants || {});
    host.appendChild(vs);

    wire(host, cfg, fid);
  }

  function wire(host, cfg, fid) {
    var form = document.getElementById(fid);
    if (!form) return;
    var bcu = host.querySelector('[data-odx-bcu]');
    var idInput = function () { return form.querySelector('input[name="id"]'); };
    function variantTitle() { var i = idInput(); var v = i && cfg.variants && cfg.variants[i.value]; return v ? v.t : ''; }

    /* show/hide option groups that only apply to some sizes; back slot follows the chosen side option */
    function sync() {
      var t = (form.__odxCustom && form.__odxCustom.on) ? 'Custom size FT' : variantTitle();
      Array.prototype.forEach.call(host.querySelectorAll('.odx-po__group'), function (g) {
        var w = g.getAttribute('data-when');
        var on = !w || new RegExp(w, 'i').test(t);
        g.hidden = !on;
        Array.prototype.forEach.call(g.querySelectorAll('input'), function (i) { i.disabled = !on; });
      });
      var back = bcu && bcu.querySelector('[data-slot]:nth-child(2)');
      var picked = host.querySelector('input[data-back]:checked:not(:disabled)');
      if (back && picked) {
        var show = picked.getAttribute('data-back') === '1';
        back.hidden = !show;
        if (!show) { var f = back.querySelector('input[type=file]'); if (f && f.value) { f.value = ''; f.dispatchEvent(new Event('change')); } }
      }
      var sized = host.querySelector('input[data-size]:checked:not(:disabled)');
      if (sized && bcu) {
        if (bcu.getAttribute('data-size') !== sized.getAttribute('data-size')) {
          bcu.setAttribute('data-size', sized.getAttribute('data-size'));
          if (/circle|round/i.test(sized.getAttribute('data-size'))) bcu.setAttribute('data-round', ''); else bcu.removeAttribute('data-round');
          if (bcu.__odxApply) bcu.__odxApply();
        }
      }
    }
    host.addEventListener('change', sync);
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-radios, variant-selects')) setTimeout(sync, 90); });
    sync();
    setTimeout(sync, 350);


    /* custom size: the customer types width × height; it is charged per square foot through a separate per-sq-ft item */
    var cs = cfg.custom && cfg.custom.id && cfg.custom.rate ? cfg.custom : null;
    if (cs) {
      var money = cfg.__money, noun = cfg.noun || 'item';
      var minSq = cs.minSqft || 1, minIn = cs.minIn || 6, maxLong = cs.maxLong || 120, maxShort = cs.maxShort || 60;
      var box = document.createElement('div');
      box.className = 'odx-pdp odx-cs';
      box.innerHTML = '<label class="odx-bc-design odx-cs__toggle"><input type="checkbox" data-cs-on><span class="odx-bc-design__box"><b>Custom size</b><small>Need a size that isn’t listed? Type your width and height and see the price.</small></span></label>' +
        '<div class="odx-cs__more" data-cs-more hidden>' +
        '<div class="odx-cs__row"><label><span>Width <em>(in)</em></span><input type="number" inputmode="decimal" min="' + minIn + '" max="' + maxLong + '" step="0.25" placeholder="e.g. 48" data-cs-w aria-label="Width in inches"></label><i aria-hidden="true">×</i>' +
        '<label><span>Height <em>(in)</em></span><input type="number" inputmode="decimal" min="' + minIn + '" max="' + maxLong + '" step="0.25" placeholder="e.g. 24" data-cs-h aria-label="Height in inches"></label></div>' +
        '<p class="odx-cs__out" data-cs-out aria-live="polite"></p>' +
        '<p class="odx-cs__fine">' + money(cs.rate) + ' per square foot, rounded up to the next whole square foot. Minimum ' + minSq + ' sq ft. Up to ' + maxLong + ' × ' + maxShort + ' in — for anything larger, call (754) 268-5972.</p>' +
        '<input type="hidden" name="properties[Custom size]" form="' + fid + '" data-cs-p1 disabled>' +
        '<input type="hidden" name="properties[Billed square feet each]" form="' + fid + '" data-cs-p2 disabled>' +
        '<input type="hidden" name="properties[Number of ' + esc(noun) + 's]" form="' + fid + '" data-cs-p3 disabled></div>';
      var picker = document.querySelector('variant-radios[data-section="' + cfg.sid + '"], variant-selects[data-section="' + cfg.sid + '"]');
      if (picker && picker.parentNode) picker.parentNode.insertBefore(box, picker.nextSibling); else host.insertBefore(box, host.firstChild);
      var csOn = box.querySelector('[data-cs-on]'), csMore = box.querySelector('[data-cs-more]'), csW = box.querySelector('[data-cs-w]'), csH = box.querySelector('[data-cs-h]'), csOut = box.querySelector('[data-cs-out]');
      var csP = [box.querySelector('[data-cs-p1]'), box.querySelector('[data-cs-p2]'), box.querySelector('[data-cs-p3]')];
      var origSize = bcu ? bcu.getAttribute('data-size') : null;
      var fmtN = function (n) { return String(Math.round(n * 100) / 100); };
      var qtyNow = function () { var qi = document.getElementById('Quantity-' + cfg.sid); return qi ? Math.max(1, parseInt(qi.value, 10) || 1) : 1; };
      var st = form.__odxCustom = { on: false, ok: false, price: 0, sqft: 0 };
      function csCalc() {
        st.on = csOn.checked; st.ok = false; st.price = 0; st.sqft = 0;
        csMore.hidden = !st.on;
        if (picker) picker.classList.toggle('odx-cs-dim', st.on);
        var w = parseFloat(csW.value), h = parseFloat(csH.value), msg = '', bad = false;
        if (st.on) {
          if (!(w > 0) || !(h > 0)) msg = 'Type the width and height in inches.';
          else if (w < minIn || h < minIn) { msg = 'The smallest size we print is ' + minIn + ' × ' + minIn + ' in.'; bad = true; }
          else if (Math.max(w, h) > maxLong || Math.min(w, h) > maxShort) { msg = 'That’s larger than we take online (' + maxLong + ' × ' + maxShort + ' in). Call (754) 268-5972 for a quote.'; bad = true; }
          else {
            var area = w * h / 144, sq = Math.max(Math.ceil(area - 1e-9), minSq);
            st.ok = true; st.sqft = sq; st.price = sq * cs.rate; st.w = w; st.h = h;
            msg = fmtN(w) + ' × ' + fmtN(h) + ' in = ' + fmtN(area) + ' sq ft' + (sq > area + 1e-9 ? ' (billed as ' + sq + ' sq ft' + (area < minSq ? ' minimum' : '') + ')' : '') + ' · ' + money(st.price) + ' each';
          }
        }
        csOut.textContent = msg; csOut.classList.toggle('is-bad', bad);
        csP.forEach(function (i) { i.disabled = !st.ok; });
        if (st.ok) { csP[0].value = fmtN(st.w) + ' × ' + fmtN(st.h) + ' in'; csP[1].value = String(st.sqft); csP[2].value = String(qtyNow()); }
        if (bcu) {
          var want = st.ok ? fmtN(st.w) + 'x' + fmtN(st.h) : origSize;
          if (bcu.getAttribute('data-size') !== want) {
            if (want) bcu.setAttribute('data-size', want); else bcu.removeAttribute('data-size');
            if (st.ok) bcu.setAttribute('data-custom-size', ''); else bcu.removeAttribute('data-custom-size');
            if (bcu.__odxApply) bcu.__odxApply();
          }
        }
        sync();
      }
      box.addEventListener('input', csCalc);
      box.addEventListener('change', csCalc);
      /* the item really added is the per-square-foot one: (billed sq ft) × (how many) */
      form.addEventListener('formdata', function (e) {
        if (!st.on || !st.ok) return;
        var n = qtyNow();
        csP[2].value = String(n);
        e.formData.set('id', String(cs.id));
        e.formData.set('quantity', String(st.sqft * n));
        e.formData.set('properties[Number of ' + noun + 's]', String(n));
      });
      form.__odxCustomCheck = function () {
        if (!st.on || st.ok) return true;
        csOut.textContent = csOut.textContent || 'Type the width and height in inches.';
        csOut.classList.add('is-bad');
        (parseFloat(csW.value) > 0 ? csH : csW).focus();
        return false;
      };
      csCalc();
    }

    /* design option */
    var cb = host.querySelector('[data-odx-design]');
    if (cb) {
      var more = host.querySelector('[data-odx-design-more]'), flag = host.querySelector('[data-odx-design-flag]'), notes = host.querySelector('[data-odx-design-notes]');
      cb.addEventListener('change', function () { more.hidden = !cb.checked; flag.disabled = !cb.checked; notes.disabled = !cb.checked; });
    }

    /* on submit (after the upload checks have passed): add paid extras as their own cart lines, then add the item */
    function onSubmit(e) {
      if (e.target !== form) return;
      if (form.__odxCustomCheck && !form.__odxCustomCheck()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      var nt = host.querySelector('[data-odx-notes]');
      if (nt && !nt.value.trim()) { nt.disabled = true; setTimeout(function () { nt.disabled = false; }, 1500); }
      if (form.__odxExtrasAdded) return;
      var qi = document.getElementById('Quantity-' + cfg.sid);
      var qty = qi ? Math.max(1, parseInt(qi.value, 10) || 1) : 1;
      var items = [];
      Array.prototype.forEach.call(host.querySelectorAll('input[data-odx-addon]:checked:not(:disabled)'), function (a) {
        items.push({ id: +a.getAttribute('data-id'), quantity: a.hasAttribute('data-once') ? 1 : qty, properties: { For: cfg.title } });
      });
      if (cb && cb.checked && cfg.design && cfg.design.id) items.push({ id: cfg.design.id, quantity: 1, properties: { For: cfg.title } });
      if (!items.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .catch(function () {})
        .then(function () {
          setTimeout(function () {
            form.__odxExtrasAdded = true;
            var btn = form.querySelector('[name="add"]');
            if (form.requestSubmit) form.requestSubmit(btn || undefined); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            setTimeout(function () { form.__odxExtrasAdded = false; }, 1500);
          }, 0);
        });
    }
    /* registered after the preview script's own checks, so nothing is added when the order is blocked */
    function listen() { document.addEventListener('submit', onSubmit, true); }
    if (document.readyState === 'complete') setTimeout(listen, 0); else window.addEventListener('DOMContentLoaded', function () { setTimeout(listen, 0); });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('script[data-odx-print]'), function (el) {
      if (el.__odx) return; el.__odx = true;
      var cfg; try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
      var host = document.getElementById('OdxPrint-' + cfg.sid);
      if (host) build(host, cfg);
    });
  }
  boot();
})();
